import { AccountMovementsViewModel } from "../../accounting/models/accounting-movement.model";

export class InvestmentPropertyModel {

  uid: string;
  accountingModelsNumber: string;
  accountingModelsId: number;
  filesInvestmentUid: string;
  contactsUid: string;
  contactsName: string;
  investmentDate: Date;
  investmentDescription: string;
  usage: number;
  maximumLinearCoefficient: number;
  maximumPeriod: number;
  residualValue: number;
  base: number;
  purchaseValueConstruction: number;
  landPurchaseValue: number;
  cadastralReference: string;
  cadastralValue: number;
  cadastralValueConstruction: number;
  cadastralValueLand: number;
  companyPremisesOrOffice: boolean;
  isImage: boolean;
  isPdf: boolean;
  paided: string;
  taxes: InvestmentPropertyTaxesModel[];
  total: number;
  projectUid: string | null;
  partida?: string | null;
  subpartida?: string | null;
  familia?: string | null;
  grantUid?: string | null;

  //Importación cuentas contables
  manualMovement: AccountMovementsViewModel;

  constructor() {
    this.cadastralReference = '';
    this.taxes = new Array<InvestmentPropertyTaxesModel>();
    this.maximumLinearCoefficient = 3;
    this.maximumPeriod = 68;
  }

}

export class InvestmentPropertyTaxesModel {
  id: number;
  name: string;
  taxImport: number;
  type: string;
}

export class InvestmentPropertyDepositsModel {

  uid: string;
  investmentPropertyId: string;
  paymentCardsUid: string;
  bankAccountsUid: string;
  amount: number;
  depositDate: Date;
  typePay: string;
  commissions: number;
  bankAccountInfo: string;
  efectivoId: string;
  partnersId: number;
  polizaCreditoId: string;

  constructor() { }

}

